<form [formGroup]="form">
  <div class="card form-card">
    <div class="card-body">
      <div class="row max-form-width">
        <div class="col-sm-6" [checkPermissions]="{ roles: ['admin', 'support', 'sales'] }">
          <input-field formControlName="quota" i18n-label="@@common.quota" label="Quota" type="number" i18n-description="@@components.tenant_configuration.general_form.quota_description" description="All pages count towards the quota. When exceeded, newly uploaded documents/batches are throttled, which means that processing is not started immediately, but after a ca. 2min delay, or longer if there is a processing backlog. Once started, they proceed normally. Counts are reset every start of the month."></input-field>
        </div>
      </div>
    </div>
  </div>
  <div class="card form-card">
    <h3 class="card-header" i18n="@@components.tenant_configuration.general_form.model_defaults">Model Defaults</h3>
    <div class="card-body">
      <div class="row max-form-width">
        <div class="col-sm-6">
          <select-field formControlName="gen_ai_model_id" i18n-label="@@common.gen_ai_model_id" label="Language Model" [options]="genAiModelOptions()"></select-field>
        </div>
        <div class="col-sm-6">
          <input-field formControlName="separation_model_id" i18n-label="@@common.separation_model_id" label="Separation Model ID" type="number"></input-field>
        </div>
      </div>
    </div>
  </div>
</form>
